/**
 * Cycle Master Data Interfaces
 * Framework-agnostic TypeScript interfaces for Cycle management
 */

export interface Cycle {
  id: number;
  quarter_id: number;
  cycle_name: string;
  /** Legacy alias used by older frequency APIs */
  target_cycle_name?: string;
  start_date: string;
  end_date: string;
  program_id?: number;
  status: number;
  quarter_name?: string;
  created_at?: string;
  updated_at?: string;
}

export interface CycleFormData {
  quarter_id: number | string;
  cycle_name: string;
  start_date: string;
  end_date: string;
  program_id: number;
  id?: number;
}

export interface CycleApiResponse {
  status: number;
  data: Cycle[];
  body?: {
    data: {
      message?: string;
    };
  };
}

export interface CycleStatusPayload {
  id: number;
  status: number;
}
